import request from './ajax_request.js'

export const base_url="/api"
export const debug_obj = {} 
// export const debug_obj = process.env.NODE_ENV === 'production'?{}:
// 	{
// 		shop_id :'558cddd574184c39d2abf993',
// 		api     :'mobile_device'
// 	}

export function base_api({method,schema,params,data}){
	let url = `${base_url}/pos/${schema}`;
	// console.log("debug_obj:",debug_obj,"url:",url);
	return request({
		url,
		method : method?method:'get',
		params :Object.assign({},debug_obj,params?params:{}),
		data   :data?data:null
	})
}




// WEBPACK FOOTER //
// ./src/api/base_api.js